<template>
  <ScrollView
    class="DashScrollContainer"
    :refreshing="refreshing"
    @onRefresh="onRefresh"
    :empty="data.length === 0"
  >
    <div class="wrapper">
      <span class="fontTotal">
        Total:
        {{
          $formatter(
            data.reduce((v, c) => v + c[suma], 0),
            moneda
          )
        }}
      </span>
      <RenderItem
        v-for="(item, index) of data"
        :key="`${item.cultivo}-${index}`"
        :item="item"
        :estructura="estructura"
        style="display: inline-flex;"
      />
    </div>
    <template slot="Empty">
      <slot name="Empty" />
    </template>
  </ScrollView>
</template>

<script>
import RenderItem from "./RenderItem.vue";
export default {
  name: "CollapseList",
  components: {
    RenderItem
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    estructura: {
      type: Object,
      default: () => ({})
    },
    suma: {
      type: String,
      default: ""
    },
    moneda: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}
.fontTotal {
  font-weight: bold;
  font-size: 25px;
  color: #000;
  text-align: right;
}
</style>
